import http from '@http';
import apis from './apis';

const axios = http();

export default class SystemService {
    static getUploadTokenUrl(params) {
        return axios.get(apis.getUploadTokenUrl, {
            params
        });
    }

    static mockLogin(cusParams) {
        let params = Object.assign(
            {
                mobileType: '+86', // 手机类型 国内手机默认 +86
                mobilePhone: '15950025010', // 手机号
                smsCode: '191231', // 短信验证码
                smsType: 2, // 请求发送短信时发送的短信验证码类型 短信类型 1 =新用户登录 2=登录 3=解绑手机 4=换绑手机
                channel: 'web', // 用户注册渠道
                deviceId: '1121313232'
            },
            cusParams
        );
        return axios.post(apis.mockLogin, params);
    }

    static actAdd(params) {
        return axios.post(apis.actAdd, params);
    }

    static getList(params) {
        return axios.get(apis.getList, {
            params
        });
    }

    static vote(params) {
        return axios.post(apis.vote, params);
    }
}
